import {
  Box,
  Button,
  Center,
  Container,
  Flex,
  Heading,
  Image,
  Text,
} from '@chakra-ui/react'
import React from 'react'
import { useSelector } from 'react-redux'
import { getZoomConnectionUrl } from '../../Api/user'
import NavbarOpen from '../NavLinks/NavbarOpen'

const ZoomLogin = () => {
  const user = useSelector((state) => state?.user?.data)

  const getConnectionUrlHandler = async () => {
    const apiResponse = await getZoomConnectionUrl(user.email)
    if (apiResponse?.url) {
      window.open(apiResponse.url, '_blank')
    }
  }

  return (
    <Container
      bg='brandBackground'
      maxW='full'
      px='131px'
      pt='48px'
      h='100vh'
    >
      <Box
        left='0'
        top='0'
        position='absolute'
      >
        <NavbarOpen />
      </Box>
      <Flex
        justify='center'
        align='center'
        h='100%'
      >
        <Box>
          <Center align='center'>
            <Flex
              direction='column'
              mt='-150px'
            >
              {' '}
              <Heading
                fontSize='5xl'
                color='black'
                px='150px'
                lineHeight='1'
                mb='4'
              >
                {' '}
                Integrate Zoom
              </Heading>
              <Text
                color='black'
                my='42px'
                alignSelf='center'
              >
                🚀 This will allow you to capture all your Zoom conversations on
                Arrowhead!
              </Text>
              <Button
                bg='white'
                _hover={{ bg: 'white' }}
                px='10px'
                border='1px solid'
                borderRadius='3xl'
                w='200px'
                mt='4'
                alignSelf='center'
                borderColor='blackAlpha.500'
                onClick={getConnectionUrlHandler}
              >
                <Flex align='center'>
                  <Box mr={2}>
                    <Image
                      src='/assets/icons/zoomLink.png'
                      boxSize={4}
                      objectFit='cover'
                    />{' '}
                  </Box>
                  <Text
                    fontSize='md'
                    color='black'
                    fontWeight='400'
                  >
                    Connect to Zoom
                  </Text>
                </Flex>
              </Button>
              <Text
                alignSelf='center'
                my='6'
              >
                <Flex align='center'>
                  <Image
                    src='/assets/icons/tickBox.svg'
                    mx='12px'
                  />
                  <Text
                    color='black'
                    fontSize='14px'
                  >
                    Delete all my recordings from Zoom server
                  </Text>
                </Flex>
              </Text>
            </Flex>
          </Center>
        </Box>
      </Flex>
    </Container>
  )
}

export default ZoomLogin
